import { jsx as _jsx } from "react/jsx-runtime";
import cx from '../../utils/classNames';
import styles from './Divider.module.css';
export var Orientation;
(function (Orientation) {
    Orientation[Orientation["VERTICAL"] = 0] = "VERTICAL";
    Orientation[Orientation["HORIZONTAL"] = 1] = "HORIZONTAL";
})(Orientation || (Orientation = {}));
const styleMapper = {
    [Orientation.VERTICAL]: styles.vertical,
    [Orientation.HORIZONTAL]: styles.horizontal,
};
export const Divider = (props) => {
    const { orientation, color } = props;
    const inlineStyle = {
        backgroundColor: color,
    };
    return (_jsx("hr", { className: cx(props.className, styles.divider, styleMapper[orientation]), style: inlineStyle }, void 0));
};
